import { IDisplayInfoIcon } from '@caslink/device-client/ng-app/shared/models/types';
import { GeneralDisplayIconFactory } from './general-display-icon-factory';
import { DisplayIconFactory } from './display-icon-factory.interface';
import { ICardDataViewModel } from '@caslink/device-client/ng-app/shared/models/models';

export class TemperatureDisplayIconFactory implements DisplayIconFactory {
    public createDisplayIcon(item: ICardDataViewModel): IDisplayInfoIcon {
        const di = new GeneralDisplayIconFactory().createDisplayIcon(item);
        di.materialIcon = 'thermostat';
        di.icon = null;
        return di;
    }
}
